<template>
    <div class="notifications-wrapper">
        <div class="notifications-container">
            <loading-notifications v-if="loading"></loading-notifications>
            <div v-else>
                <div v-for="item in notifications" :key="item.id">
                    <item :value="item" :type="item.action"></item>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Item from '@/components/Notification/Item'
import LoadingNotifications from '@/components/Loadings/Notification'
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    Item,
    LoadingNotifications
  },
  metaInfo: {
    title: 'Notifications'
  },
  data () {
    return {
      loading: false,
      err: null
    }
  },
  computed: {
    ...mapGetters({
      notifications: 'notification/notifications'
    })
  },
  mounted () {
    this.fetch()
    this.seen()
  },
  methods: {
    ...mapActions({ seen: 'notification/seen' }),
    ...mapMutations({
      setNotifications: 'notification/setNotifications'
    }),
    async fetch () {
      this.loading = true
      try {
        const params = { offset: 0, limit: 25 }
        const response = await this.axios.get('/api/notifications', { params })
        const data = response.data.data
        this.setNotifications(data)
        this.loading = false
      } catch (err) {
        this.err = err.response.data.message
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss">
.notifications-wrapper {
  height: 100%;
  margin-top: -58px;
  position: relative;
  overflow: hidden;
  padding-top: 58px;
  .notifications-container {
    height: calc(100%);
    overflow: auto;
  }
}
</style>
